<template>
  <div class="whiteBg login-page-wrapper" :class="{ darkModeEnabled: isDarkMode }">
    <div class="pad_zero loginContainer">
      <div class="login-row">
        <div class="login-col-form">
          <div class="logo-section">
            <div class="width100P text-center">
              <img v-if="isDarkMode" src="../../resources/images/login-page-logo-dark.svg" alt="dark_mode" class="headerLogo" />
              <img v-else src="../../resources/images/login-page-logo.svg" alt="login_page" class="headerLogo" />
            </div>
          </div>
          <div class="form-wrapper" :class="{ selectAccountWrapper : loginStatus === 'halfway' }">
            <div v-if="loginMode" class="form-container">
              <div v-if="forgotMode" class="frm-header text-center">
                <h1 class="header ion-no-margin text-center">Forgot Password</h1>
                <h2 class="sub-header ion-no-margin text-center">Please enter your email</h2>
              </div>
              <div v-else class="frm-header text-center">
                <h1 class="header ion-no-margin text-center">Sign in</h1>
                <h2 v-if="loginStatus === 'pending'" class="sub-header ion-no-margin text-center">Please enter your details</h2>
                <h2 v-else-if="loginStatus === 'mfa'" class="sub-header ion-no-margin text-center">
                  <span v-if="mfa.type === 'email'">Enter the OTP sent to your email</span>
                  <span v-else>Enter your Google Authenticator code</span>
                  <div v-if="mfa.type === 'email' && formattedTimer !== '00:00'" class="smallText">OTP is valid for 5 minutes and will expire in {{ formattedTimer }}</div>
                </h2>
                <h2 v-else-if="loginStatus === 'force-mfa'" class="sub-header ion-no-margin text-center">Please setup a security method:</h2>
                <h2 v-else-if="loginStatus === 'halfway'" class="sub-header ion-no-margin text-center">Please select an account:</h2>
              </div>
              <!-- <div v-if="loginStatus === 'pending'" class="env-row">
                <div v-for="(thisEnv, eIndex) in availableEnvs" :key="eIndex" class="tag" :class="{ selected: selectedEnv === thisEnv.value }" @click="changeEnv(thisEnv.value)" >{{ thisEnv.name }}</div>
              </div> -->
                <form v-if="forgotMode" key="forgot-password-form" @submit.prevent="forgotPassword">
                <VTextField @keyup.enter="forgotPassword" name="email" :disabled="loginSpinner" type="text" aria-label="email" appearance="ghost" class="vivid-input sctn-input marginBottom" v-model="forgot.email" placeholder="Email" />
                <RecaptchaV2 v-if="showRecaptcha" key="forgot-recaptcha" @load-callback="(e) => { forgot.reCaptcha = e; }" class="marginTop10P marginBottom width100" />
                <VButton connotation="cta" appearance="filled" class="bttnPrimary ion-no-margin marginBottom" @click="forgotPassword" :disabled="!forgot.email?.trim() || !forgot.reCaptcha" label="Send Reset Link"> </VButton>
                <span @click="() => { forgotMode = false; forgot.reCaptcha = undefined; }" class="forgot-password-link">Login?</span>
              </form>
              <div v-else>
                <form v-if="loginStatus === 'pending'" key="login-form" @submit.prevent="login">
                  <VTextField @keyup.enter="login" name="username" :disabled="loginSpinner" type="text" aria-label="login" :maxlength="150" appearance="ghost" class="vivid-input sctn-input marginBottom" v-model="userInfo.username" placeholder="Username" />
                  <div class="passwordField marginBottom width100P">
                    <VTextField @keyup.enter="login" name="password" :disabled="loginSpinner" :type="showLoginPassword ? 'text' : 'password'" aria-label="password" appearance="ghost" class="vivid-input sctn-input" v-model="userInfo.password" placeholder="Password" />
                    <VIcon :name="showLoginPassword ? eyeOutline : eyeOffOutline" @click="showLoginPassword = !showLoginPassword" class="passwordToggle" />
                  </div>
                  <RecaptchaV2 v-if="showRecaptcha" key="login-recaptcha" @load-callback="(e) => { userInfo.reCaptcha = e; }" class="marginBottom width100" />
                  <VButton connotation="cta" appearance="filled" class="bttnPrimary ion-no-margin marginBottom" @click="login" :disabled="!userInfo.username || !userInfo.password || !userInfo.reCaptcha" label="Login"> </VButton>
                  <span @click="() => { forgotMode = true; userInfo.reCaptcha = undefined; }" class="forgot-password-link">Forgot Password?</span>
                  <div class="sso-login-wrapper">
                    <div class="or-text">OR</div>
                    <div class="title">Sign in with SSO</div>
                    <div class="input-button-wrapper">
                      <VTextField v-model="domain" type="email" placeholder="Domain or Email" appearance="ghost" class="vivid-input sctn-input" />
                      <VButton :disabled="!domain || isLoading" @click="fetchProviderConfig" appearance="filled" connotation="cta" aria-label="Submit" style="margin-left: 15px">
                        <template #icon><VIcon name="chevron-right-line" /></template>
                      </VButton>
                    </div>
                  </div>
                </form>
                <form v-else-if="loginStatus === 'mfa'" key="mfa-form" @submit.prevent="verifyMFA">
                  <div v-if="!mfa.activation && mfa.qr" class="width100P">
                    <MfaSteps :qrCode="mfa.qr" />
                  </div>
                  <InputNumber name="otp" maxlength="8" :disabled="loginSpinner" @keyup.enter="verifyMFA" v-model="mfaOTP" :allowDecimal="false" :placeholder="`Enter ${mfa.type === 'email' ? 'OTP' : 'Google Authenticator Code'}`" ariaLabel="otp" :class="{ marginBottom: mfa.type !== 'email' }"> </InputNumber>
                  <span v-if="mfa.type === 'email'" style="display: flex; width: 100%;font-size: 0.8rem; margin: 10px 0 20px 0;">
                    <span v-if="formattedTimer === '00:00'">Your OTP has expired. Please click on <span @click="resendOtp" style="color: var(--purple); font-weight: bold; cursor: pointer;">Resend OTP</span></span>
                    <span v-else>Haven't received the OTP? Please check your spam folder or click on <span @click="resendOtp" style="color: var(--purple); font-weight: bold; cursor: pointer;">Resend OTP</span></span>
                  </span>
                  <VButton connotation="cta" appearance="filled" class="bttnPrimary" @click="verifyMFA" label="Verify"> </VButton>
                </form>
                <form v-else-if="loginStatus === 'force-mfa'" key="force-mfa-form" @submit.prevent="verifyMFA" class="forceMFA">
                  <div>
                    <div class="info-box marginBottom">
                      <VIcon name="info-line" :size="-5" connotation="cta" class="infoIcon"></VIcon>
                      <p class="title ion-no-margin">Only one MFA option can be enabled at a time.</p>
                    </div>
                    <div class="marginBottom innerContainer">
                      <div class="column flex-between">
                        <div class="authContainer">
                          <VIcon name="envelope-line" class="mailIcon"></VIcon>
                          <div>
                            <p class="customer-info-title paddingBottom5P ion-no-margin">Email OTP</p>
                            <p class="sub-title ion-no-margin">Setup email to login with an OTP</p>
                          </div>
                        </div>
                        <VButton @click="enableMFA('email')" connotation="cta" appearance="filled" class="bttnPrimary ion-no-margin" :disabled="isLoading" :label="!isLoading ? 'Setup' : 'Loading...'" />
                      </div>
                    </div>
                    <div class="innerContainer">
                      <div class="column flex-between">
                        <div class="authContainer">
                          <img src="@/resources/images/google-authenticator-logo.png" alt="authenticator" width="40"/>
                          <div>
                            <p class="customer-info-title paddingBottom5P ion-no-margin">Google Authenticator</p>
                            <p class="sub-title ion-no-margin">Setup Google Authenticator to login with a code</p>
                          </div>
                        </div>
                        <VButton @click="enableMFA('google')" connotation="cta" appearance="filled" class="bttnPrimary ion-no-margin" :disabled="isLoading" :label="!isLoading ? 'Setup' : 'Loading...'" />
                      </div>  
                    </div>
                  </div>
                </form>
                <div v-else-if="loginStatus === 'halfway'" class="chooseAccountContainer">
                  <div v-if="accounts.length">
                    <div v-for="(thisAccount, aIndex) in accounts" :key="aIndex" @click="chooseLoginAccount(thisAccount.shop_name)" class="account-item">
                      <div class="account-item-avatar">
                        <img src="@/resources/images/shop-image-placeholder.png" alt="shop_placeholder" loading="lazy" class="img-responsive" />
                      </div>
                      <div class="account-item-label">
                        <h2 class="title custPadding">{{ thisAccount.shop_name }}</h2>
                      </div>
                      <VIcon name="chevron-right-line" style="color: white" />
                    </div>
                  </div>
                </div>
                <div v-if="!['pending', 'halfway'].includes(loginStatus)" class="back-text">
                  <template v-if="loginStatus === 'mfa' && !mfa.activation">
                    <span @click="setLoginStatus('force-mfa')" class="clickable">Change Security Method</span>
                    <span>or</span>
                  </template>
                  <span @click="setLoginStatus('pending')" class="clickable">Go back to Login Screen</span>
                </div>
              </div>
            </div>
            <div v-else class="form-container">
              <div v-if="changePassword.code" class="frm-header text-center">
                <h1 class="header ion-no-margin text-center">Reset your password</h1>
                <h2 class="sub-header ion-no-margin text-center">Choose a new password</h2>
              </div>
              <div v-else-if="newUser.code" class="frm-header text-center">
                <h1 class="header ion-no-margin text-center">Welcome! Let's set up your account</h1>
                <h2 v-if="!newUser.emailValidated" class="sub-header ion-no-margin text-center">Please enter the email associated with your account</h2>
                <h2 v-else class="sub-header ion-no-margin text-center">Create a super secure password</h2>
              </div>
              <form v-if="changePassword.code" key="change-password-form" @submit.prevent="changeUserPassword">
                <div class="passwordField marginBottom">
                  <VTextField name="new-password" :disabled="loginSpinner" :type="showChangePassword ? 'text' : 'password'" aria-label="new-password" appearance="ghost" class="vivid-input sctn-input" v-model="changePassword.password" placeholder="New Password" />
                  <VIcon :name="showChangePassword ? eyeOutline : eyeOffOutline" @click="showChangePassword = !showChangePassword" class="passwordToggle" />
                </div>
                <div class="passwordField marginBottom">
                  <VTextField @keyup.enter="changeUserPassword" name="confirm-password" :disabled="loginSpinner" :type="showChangePasswordConfirm ? 'text' : 'password'" aria-label="confirm-password" appearance="ghost" class="vivid-input sctn-input" v-model="changePassword.password_confirmation" placeholder="Confirm Password" />
                  <VIcon :name="showChangePasswordConfirm ? eyeOutline : eyeOffOutline" @click="showChangePasswordConfirm = !showChangePasswordConfirm" class="passwordToggle" />
                </div>
                <check-password :password="changePassword.password" @validated="e => changePassword.isValidPassword = e" />
                <RecaptchaV2 v-if="showRecaptcha" key="change-password-recaptcha" @load-callback="(e) => { changePassword.reCaptcha = e; }" class="marginTop10P marginBottom width100" />
                <VButton connotation="cta" appearance="filled" class="bttnPrimary marginBottom20P" @click="changeUserPassword" :disabled="!changePassword.password?.trim() || !changePassword.reCaptcha" label="Change Password"> </VButton>
                <VButton appearance="outlined" class="bttnSecondary" @click="() => { $router.replace({ path: '/login', query: null }); loginMode = true; }" label="Go to Login"> </VButton>
              </form>
              <div v-else-if="newUser.code">
                <form v-if="!newUser.emailValidated" key="new-user-email-form" @submit.prevent="validateNewUserEmail">
                  <VTextField @keyup.enter="validateNewUserEmail" name="email" :disabled="loginSpinner" type="text" aria-label="email" :maxlength="150" appearance="ghost" class="vivid-input sctn-input marginBottom" v-model="newUser.email" placeholder="Email" />
                  <VButton connotation="cta" appearance="filled" class="bttnPrimary ion-no-margin marginBottom" @click="validateNewUserEmail" :disabled="!newUser.email" label="Proceed"> </VButton>
                </form>
                <form v-else key="new-user-password-form" @submit.prevent="onboardNewUser">
                  <div class="passwordField marginBottom width100P">
                    <VTextField name="new-password" :disabled="loginSpinner" :type="showNewUserPassword ? 'text' : 'password'" aria-label="new-password" appearance="ghost" class="vivid-input sctn-input" v-model="newUser.password" placeholder="Password" />
                    <VIcon :name="showNewUserPassword ? eyeOutline : eyeOffOutline" @click="showNewUserPassword = !showNewUserPassword" class="passwordToggle" />
                  </div>
                  <div class="passwordField marginBottom width100P marginBottom20P">
                    <VTextField @keyup.enter="onboardNewUser" name="confirm-password" :disabled="loginSpinner" :type="showNewUserPasswordConfirm ? 'text' : 'password'" aria-label="confirm-password" appearance="ghost" class="vivid-input sctn-input" v-model="newUser.password_confirmation" placeholder="Confirm Password" />
                    <VIcon :name="showNewUserPasswordConfirm ? eyeOutline : eyeOffOutline" @click="showNewUserPasswordConfirm = !showNewUserPasswordConfirm" class="passwordToggle" />
                  </div>
                  <check-password :password="newUser.password" @validated="e => newUser.isValidPassword = e" />
                  <RecaptchaV2 v-if="showRecaptcha" key="new-user-recaptcha" @load-callback="(e) => { newUser.reCaptcha = e; }" class="marginBottom width100" />
                  <VButton connotation="cta" appearance="filled" class="bttnPrimary marginBottom" @click="onboardNewUser" :disabled="!newUser.password || !newUser.reCaptcha" label="Proceed"> </VButton>
                  <VButton appearance="outlined" class="bttnSecondary" @click="() => { $router.replace({ path: '/login', query: null }); loginMode = true; }" label="Go to Login"> </VButton>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div class="login-col-image">
          <div class="width100P text-center">
            <ImageSlider>
              <img class="loginIllustration_onTheRight" src="../../resources/images/login-img-1.svg" />
              <img class="loginIllustration_onTheRight" src="../../resources/images/login-img-2.svg" />
              <img class="loginIllustration_onTheRight" src="../../resources/images/login-img-3.svg" />
              <img class="loginIllustration_onTheRight" src="../../resources/images/login-img-4.svg" />
              <img class="loginIllustration_onTheRight" src="../../resources/images/login-img-5.svg" />
              <img class="loginIllustration_onTheRight" src="../../resources/images/login-img-6.svg" />
            </ImageSlider>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>


import ImageSlider from "/src/components/ImageSlider.vue";
import MfaSteps from "/src/components/mfa-steps.vue";
import moment from "moment";
import InputNumber from "/src/components/inputNumber.vue";
import checkPassword from "@/components/checkPassword.vue";

var intervalId;

import { RecaptchaV2 } from "vue3-recaptcha-v2";
import apiInterceptor from '@/shared/apiInterceptor';
import { clearQueryCache } from '@/shared/queryClient';
import { useAuthStore } from '@/stores/auth';
import { useUIStore } from '@/stores/ui';
import { Preferences as Storage } from '@capacitor/preferences';
import { environment } from '@/shared/env';
import { isLive, isEuServer } from '@/helpers/env.helpers';
import { validateEmail } from '@/helpers/validation.helpers';

export default {
  components: { ImageSlider, InputNumber, MfaSteps, RecaptchaV2, checkPassword },
  data() {
    return {
      Storage,
      now: Date.now(),
      showRecaptcha: false,
      showLoginPassword: false,
      showChangePassword: false,
      showChangePasswordConfirm: false,
      showNewUserPassword: false,
      showNewUserPasswordConfirm: false,
      eyeOutline: 'eye-line',
      eyeOffOutline: 'eye-hide-line',
      allEnvs: [
        { name: "USA Staging", value: 'staging', dev: true },
        { name: "USA Region", value: 'production' },
        { name: "Europe Region", value: 'eu_production' }
      ],
      userInfo: {
        username: "",
        password: "",
        reCaptcha: undefined
      },
      jupiterUser: {
        accessToken: undefined,
        refreshToken: undefined
      },
      loginSpinner: false,
      forgotMode: false,
      forgot: {
        email: undefined,
        reCaptcha: undefined
      },
      mfaOTP: undefined,
      sentOTPAt: undefined,
      selectedEnv: undefined,
      loginMode: true,
      changePassword: {
        code: undefined,
        password: undefined,
        reCaptcha: undefined,
        isValidPassword: false,
        password_confirmation: undefined
      },
      newUser: {
        code: undefined,
        email: undefined,
        emailValidated: true,
        password: undefined,
        reCaptcha: undefined,
        isValidPassword: false,
        password_confirmation: undefined
      },
      domain: "",
    };
  },
  async mounted() {
    try {
      this.selectedEnv = (await this.Storage.get({ key: "environment" }))?.value || process.env.VUE_APP_NODE_ENV;
      
      // Delay RecaptchaV2 rendering to ensure DOM is ready
      await this.$nextTick();
      setTimeout(() => {
        this.showRecaptcha = true;
      }, 100);
      
      if(isLive()) {
        if(isEuServer() && this.selectedEnv !== 'eu_production') this.changeEnv('eu_production');
        else if(!isEuServer() && this.selectedEnv === 'eu_production') this.changeEnv('production');
      } else if(this.selectedEnv !== 'staging') this.changeEnv('staging');

      if (this.$route.query?.changePassword){
        if(this.loginStatus === 'success'){
          useAuthStore().logoutUser();
          location.reload();
        }
      }
      else{
        if(this.loginStatus === 'success') this.$router.replace({ path: '/dashboard' });
      }

      // Proactively clear any persisted query cache when an unauthenticated user
      // reaches the login page (covers crash/force-close scenarios where logout
      // did not run and the jmpr_cache_owner stamp was never written).
      if (this.loginStatus !== 'success') await clearQueryCache();

      intervalId = setInterval(() => {
        this.now = moment(Date.now());
      }, 1000);
      
      if (this.$route.query?.changePassword || this.$route.query?.newUser) {
        /* if(this.$route.query?.region && this.selectedEnv !== this.$route.query.region) this.changeEnv(this.$route.query.region); */
        this.loginMode = false;
        this.changePassword.code = this.$route.query?.changePassword;
        this.newUser.code = this.$route.query?.newUser;
      } else {
        if (this.$route.query?.superhuman_token) this.jupiterUser.accessToken = this.$route.query.superhuman_token;
        if (this.$route.query?.superhuman_refresh_token) this.jupiterUser.refreshToken = this.$route.query.superhuman_refresh_token;
      }
      
      useUIStore().updateLoading({ isLoading: true, message: 'Authenticating user...' });

      if(this.jupiterUser.accessToken) {
        await this.clearStorageData();
        await useAuthStore().loginJupiterUser(this.jupiterUser);
        useUIStore().updateLoading({ isLoading: false });
        switch(this.loginStatus) {
          case 'success': {
            useUIStore().updateToast({
              open: true,
              message: "Welcome Back, You are successfully logged in!",
              type: "success"
            });
            this.redirectToHome();
          }
          break;
          case 'halfway': {
            useUIStore().updateToast({
              open: true,
              message: "Please Choose the Account you want to Login",
              type: "warning"
            })
          }
          break;
          default: useUIStore().updateToast({
            open: true,
            message: "Please enter valid user details!",
            type: "danger"
          })
        }
      }
      else {
        useUIStore().updateLoading({ isLoading: false });
      }
    } catch (error) {
      console.error("Exception", error);
      useUIStore().updateToast({ open: true, message: "Something went wrong! Try again later.", type: "warning" })
    }
  },
  beforeUnmount(){
    clearInterval(intervalId);
  },
  computed: {
    isDarkMode() { return useUIStore().isDarkMode; },
    isLoading() { return useUIStore().isLoading; },
    loginStatus() { return useAuthStore().loginStatus; },
    mfa() { return useAuthStore().mfa; },
    accounts() {
      return useAuthStore().getMultipleAccounts;
    },
    formattedTimer(){
      if (!this.mfa?.expiry) return '00:00';
      const ms = moment(this.mfa.expiry).diff(this.now);
      if(ms > 0) return moment.utc(ms).format("mm:ss");
      return '00:00';
    },
    availableEnvs(){
      if(process.env.VUE_APP_NODE_ENV.includes('production')) return this.allEnvs.filter(e => !e.dev);
      else return this.allEnvs.filter(e => e.dev);
    },
  },
  methods: {
    setLoginStatus(status) { useAuthStore()._saveLoginStatus(status); },
    redirectToHome() { this.$router.replace({ path: '/dashboard', query: null }); },
    async resendOtp() {
      const ms = this.now.diff(this.sentOTPAt);
      if(ms > 0) {
        if(ms >= 30000) {
          useUIStore().updateLoading({ isLoading: true, message: 'Resending OTP...' });
          const response = await useAuthStore().resendMfaOtp();
          if(response === true) {
            useUIStore().updateToast({ open: true, message: "OTP has been sent to your email", type: "success" });
            this.sentOTPAt = moment();
          } else {
            if(response.status === 401) {
              useUIStore().updateToast({ open: true, message: response.data?.detail, type: "danger" });
              useAuthStore()._saveLoginStatus('pending');
            }
          }
          useUIStore().updateLoading({ isLoading: false });
        } else {
          useUIStore().updateToast({ open: true, message: `Please wait ${moment.utc(30000 - ms).format("ss")} seconds to resend the OTP`, type: "warning" })
        }
      }
    },
    async changeEnv(env) {
      await this.Storage.set({
        key: "environment",
        value: env,
      });
      location.reload();
    },
    checkLoginStatus(response) {
      switch(this.loginStatus) {
        case 'success': {
          useUIStore().updateToast({ open: true, message: "Welcome Back, You are successfully logged in!", type: "success" });
          this.redirectToHome();
        }
        break;
        case 'mfa': {
          useUIStore().updateToast({ open: true, message: `Please enter the OTP from your ${this.mfa.type === 'email' ? 'Email' : 'Google Authenticator'}`, type: "warning" });
          if(this.mfa.type === 'email') this.sentOTPAt = moment();
        }
        break;
        case 'force-mfa': {
          useUIStore().updateToast({ open: true, message: "Please setup a security method!", type: "success" });
        }
        break;
        case 'halfway': {
          useUIStore().updateToast({ open: true, message: "Please Choose the Account you want to Login", type: "warning" })
        }
        break;
        default: {
          let errorMessage = "Please enter valid user details!";
          if (response?.data?.detail) {
            errorMessage = response?.data?.detail;
          }
          useUIStore().updateToast({ open: true, message: errorMessage, type: "danger" });
          return false;
        }
      }
      return true;
    },
    async login() {
      if(!this.selectedEnv) return useUIStore().updateToast({ open: true, message: "Please select the region", type: "warning" });
      if(!this.userInfo.reCaptcha) return useUIStore().updateToast({ open: true, message: "Please select I'm Not a Robot", type: "warning" });

      this.loginSpinner = true;
      useUIStore().updateLoading({ isLoading: true, message: 'Logging in...' });
      if (this.userInfo.username && this.userInfo.password) {
        this.userInfo.username = this.userInfo.username.toLowerCase();
        const response = await useAuthStore().loginUser(this.userInfo);
        const status = this.checkLoginStatus(response);
        if(!status) {
          this.showRecaptcha = false;
          await this.$nextTick();
          this.showRecaptcha = true;
        }
        this.loginSpinner = false;
        useUIStore().updateLoading({ isLoading: false });
      } else {
        this.loginSpinner = false;
        useUIStore().updateLoading({ isLoading: false });
        useUIStore().updateToast({ open: true, message: "Please enter proper credentials", type: "warning" })
      }
    },
    async chooseLoginAccount (shop_name) {
      useUIStore().updateLoading({ isLoading: true, message: 'Selecting account...' });
      const response = await useAuthStore().loginUser({shop_name});
      if(this.loginStatus === 'success') {
        useUIStore().updateToast({ open: true, message: "Welcome Back, You are successfully logged in!", type: "success" });
        this.redirectToHome();
      } else {
        useUIStore().updateToast({ open: true, message: response?.data?.detail || "Login Failed!", type: "danger" })
      }
      useUIStore().updateLoading({ isLoading: false });
    },
    async clearStorageData() {
      await clearQueryCache();
      await this.Storage.set({
        key: "access_token",
        value: undefined,
      });
      await this.Storage.set({
        key: "refresh_token",
        value: undefined,
      });
      await this.Storage.set({
        key: "multipleTokens",
        value: undefined,
      });
      await this.Storage.set({
        key: "authkey",
        value: undefined,
      });
      await this.Storage.set({
        key: "user",
        value: null,
      });
    },
    async forgotPassword() {
      try {
        let email = this.forgot.email?.trim().toLowerCase() || ""; 
        if (!validateEmail(email)) {
          useUIStore().updateToast({ open: true, message: "Please enter a valid email address.", type: "danger" });
          return;
        }
        if(!this.selectedEnv) return useUIStore().updateToast({ open: true, message: "Please select the region", type: "warning" });
        if(!this.forgot.reCaptcha) return useUIStore().updateToast({ open: true, message: "Please select I'm Not a Robot", type: "warning" });
        this.loginSpinner = true;
        useUIStore().updateLoading({ isLoading: true, message: 'Sending reset link...' });
        let reqBody = {
          email,
          reCaptcha: this.forgot.reCaptcha
        };
        await apiInterceptor.post(environment('VUE_APP_API_URL') + "auth/password/reset/code", reqBody);
        useUIStore().updateToast({
          open: true,
          message: `An email with the necessary instructions has been sent to ${email}, if the address is valid.`,
          type: "success"
        });
        this.forgotMode = false;
      } catch (error) {
        console.error("Exception: ", error);
      } finally {
        this.loginSpinner = false;
        useUIStore().updateLoading({ isLoading: false });
      }
    },
    async enableMFA(type) {
      try {
        useUIStore().updateLoading({ isLoading: true, message: 'Enabling MFA...' });
        const response = await useAuthStore().loginUser({forceMFAType: type});
        if(this.loginStatus === 'mfa') {
          useUIStore().updateToast({ open: true, message: `Please enter the ${type === 'email' ? 'otp' : 'code'} from your ${type === 'email' ? 'Email' : 'Google Authenticator'}`, type: "success" });
        } else {
          useUIStore().updateToast({ open: true, message: response?.data?.detail || "Login Failed!", type: "danger" })
        }
      } catch (error) {
        console.error("Exception: ", error);
      } finally {
        useUIStore().updateLoading({ isLoading: false });
      }
    },
    async verifyMFA() {
      try {
        if(!this.mfaOTP?.length) return useUIStore().updateToast({ open: true, message: `Please enter the OTP from your ${this.mfa.type === 'email' ? 'Email' : 'Google Authenticator'}`, type: "warning" });
        this.loginSpinner = true;
        useUIStore().updateLoading({ isLoading: true, message: 'Verifying MFA...' });
        const response = await useAuthStore().loginUser({mfaOTP: this.mfaOTP});
        if(this.loginStatus === 'halfway') {
          useUIStore().updateToast({ open: true, message: "Please Choose the Account you want to Login", type: "warning" })
        } else if(this.loginStatus === 'success') {
          useUIStore().updateToast({ open: true, message: "Welcome Back, You are successfully logged in!", type: "success" });
          this.redirectToHome();
        } else {
          useUIStore().updateToast({ open: true, message: response?.data?.detail || "Login Failed!", type: "danger" })
        }
      } catch (error) {
        useUIStore().updateToast({ open: true, message: error.data?.detail || 'Unable to verify', type: "error" });
        console.error("Exception: ", error);
      } finally {
        this.loginSpinner = false;
        useUIStore().updateLoading({ isLoading: false });
        this.mfaOTP = undefined;
      }
    },
    async changeUserPassword() {
      try {
        if(!this.changePassword.isValidPassword) {
          useUIStore().updateToast({
            open: true,
            message: "Please fulfill the password validations",
            type: "warning"
          });
          return;
        }
        if(this.changePassword.password_confirmation !== this.changePassword.password) {
          useUIStore().updateToast({
            open: true,
            message: "Both passwords should be same",
            type: "warning"
          });
          return;
        }
        this.loginSpinner = true;
        await apiInterceptor.post(environment("VUE_APP_API_URL") + "auth/password/reset", {
          code: this.changePassword.code,
          password: this.changePassword.password,
          reCaptcha: this.changePassword.reCaptcha,
          password_confirmation: this.changePassword.password_confirmation
        });
        useUIStore().updateToast({
          open: true,
          message: "Password changed successfully!",
          type: "success"
        })
        this.$router.replace({ path: '/login', query: null });
        this.loginMode = true;
      } catch (error) {
        useUIStore().updateToast({
          open: true,
          message: error.message || "Something went wrong",
          type: "danger"
        })
        this.$router.replace({ path: '/login', query: null });
        this.loginMode = true;
      } finally {
        this.loginSpinner = false;
      }
    },
    async validateNewUserEmail() {
      try {
        this.loginSpinner = true;
        this.newUser.emailValidated = true;
        await apiInterceptor.post(environment("VUE_APP_API_URL") + "login-email", {
          code: this.newUser.code,
          email: this.newUser.email
        });
        useUIStore().updateToast({
          open: true,
          message: "Email validated successfully!",
          type: "success"
        })
        this.newUser.emailValidated = true;
      } catch (error) {
        useUIStore().updateToast({
          open: true,
          message: error.message || "Something went wrong",
          type: "danger"
        })
      } finally {
        this.loginSpinner = false;
      }
    },
    async onboardNewUser() {
      try {
        this.loginSpinner = true;
        if(!this.newUser.isValidPassword) {
          useUIStore().updateToast({
            open: true,
            message: "Please fulfill the password validations",
            type: "warning"
          });
          return;
        }
        if(this.newUser.password_confirmation !== this.newUser.password) {
          useUIStore().updateToast({
            open: true,
            message: "Both passwords should be same",
            type: "warning"
          });
          return;
        }
        await apiInterceptor.post(environment("VUE_APP_API_URL") + "auth/password/reset", {
          code: this.newUser.code,
          password: this.newUser.password,
          reCaptcha: this.newUser.reCaptcha,
          password_confirmation: this.newUser.password_confirmation
        });
        useUIStore().updateToast({
          open: true,
          message: "Welcome to Jumper! Please login to continue.",
          type: "success"
        })
        this.$router.replace({ path: '/login', query: null });
        this.loginMode = true;
      } catch (error) {
        useUIStore().updateToast({
          open: true,
          message: error.message || "Something went wrong",
          type: "danger"
        })
        this.$router.replace({ path: '/login', query: null });
        this.loginMode = true;
      } finally {
        this.loginSpinner = false;
      }
    },
    async fetchProviderConfig() {
      if(!this.selectedEnv) return useUIStore().updateToast({ open: true, message: "Please select the region", type: "warning" });
      if(!this.domain) return useUIStore().updateToast({ open: true, message: "Please enter your email (e.g., example@yourcompany.com)", type: "warning" });
      const lookupDomain = this.domain?.includes("@") ? this.domain?.split("@")[1] : this.domain;
      if(!lookupDomain?.length) return useUIStore().updateToast({ open: true, message: "Please enter a valid email address", type: "warning" });
      this.loginSpinner = true;
      useUIStore().updateLoading({ isLoading: true, message: 'Fetching SSO provider...' });
      const response = await useAuthStore().loginUser({ lookupDomain });
      this.checkLoginStatus(response);
      this.loginSpinner = false;
      useUIStore().updateLoading({ isLoading: false });
    }
  },
};
</script>

<style lang="scss" scoped src="../../resources/css/settings.scss"> </style>
<style lang="scss" scoped>
.logo-section {
  padding: 20px;
}
.login-page-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100vw;
  .loginContainer {
    width: -webkit-fit-content;
    @include mobile {
      width: auto;
    }
    @include tablet {
      width: auto;
    }
  }
}
.login-row {
  display: flex;
  flex-direction: row;
  width: 100%;
}
.login-col-form {
  flex: 0 0 33.33%;
  max-width: 33.33%;
  padding: 0;
  @media (max-width: 991px) {
    flex: 0 0 100%;
    max-width: 100%;
  }
}
.login-col-image {
  flex: 0 0 66.67%;
  max-width: 66.67%;
  padding: 0;
  background-color: #f2f2f2;
  @media (max-width: 991px) {
    display: none;
  }
}
.darkModeEnabled .login-col-image {
  background-color: #121212;
}
.form-wrapper {
  min-height: 350px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.form-container {
  width: 100%;
  padding: 20px;
  form {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 10px;
  }
}
.frm-header {
  margin-bottom: 20px;
}
.vivid-input {
  background: var(--background-primary);
  border-radius: 5px;
  min-height: 40px;
  width: 100%;
}
.bttnPrimary,
.bttnSecondary {
  width: 100%;
  height: 40px;
}
.loginIllustration_onTheRight{
    padding: 50px;
    width: auto;
    height: auto;
    max-width: 100%;
    max-height: 100dvh;
    padding: 18vh 0px;
}
.header{
  font-weight: bold;
  font-size: 2rem;
  line-height: 120%;
  color: var(--black);
  padding-bottom: 10px;
}
.sub-header{
  font-size: 1.1rem;
  color: var(--black);
  .smallText {
    font-size: 0.8rem;
    margin: 10px 0;
  }
}
.marginBottom{
  margin-bottom: 10px;
}
.account-item {
  display: flex;
  align-items: center;
  gap: 12px;
  background: var(--background-primary);
  border-radius: 5px;
  margin-bottom: 10px;
  cursor: pointer;
  padding: 10px 16px;
  &:hover {
    background: var(--purple);
    .title, .sub-title {
      color: var(--white);
    }
  }
}
.account-item-avatar {
  flex-shrink: 0;
}
.account-item-label {
  flex: 1;
}
.img-responsive{
  width: 40px;
  height: 40px;
  border-radius: 5px;
}
.title {
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: var(--black);
}
.custPadding{
  padding-bottom: 5px;
}
.sub-title{
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: var(--gray-04);
}
.chooseAccountContainer{
  margin-bottom: 0px;
  height: 500px;
  min-height: 450px;
  overflow: hidden;
  overflow-y: auto; 
}
.headerLogo {
  height: 30px;
}
.forgot-password-link {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 5px;
  font-size: 0.9rem;
  color: var(--gray-04);
  cursor: pointer;
}

.env-row {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-bottom: 20px;
}

.qr-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: center;
  margin-bottom: 10px;
  gap: 10px;
  .qr-code {
    display: flex;
    flex-direction: row;
    align-content: center;
    align-items: center;
    justify-content: center;
    width: 100%;
  }
}
.tag {
  border: 1px solid #dcdcdc;
  padding: 5px 10px;
  border-radius: 8px;
  background-color: var(--background);
  color: var(--purple);
  margin: 10px;
  cursor: pointer;
  text-align: center;
}
.tag.selected {
  background-color: var(--purple);
  color: var(--white);
}
.back-text {
  font-size: 0.9rem;
  line-height: 140%;
  padding: 0 15px;
  span:not(:first-child) {
    padding: 0 3px;
  }
  .clickable {
    color: var(--purple);
    cursor: pointer;
  }
}
.authContainer {
  width: 100%;
}
.sso-login-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid var(--background-primary);
  position: relative;
  .or-text {
    position: absolute;
    top: -0.5rem;
    font-size: 1rem;
    background-color: var(--white);
    padding: 0 10px;
  }
  .title {
    font-size: 1.1rem;
    margin: 10px 0;
  }
  .input-button-wrapper {
    display: flex;
    width: 100%;
    flex-direction: row;
    padding: 10px 0;
    .vivid-input.sctn-input {
      flex: 1;
      height: 40px;
      font-size: 0.9rem;
    }
    .next-btn {
      width: 40px;
      height: 40px;
      margin-left: 10px;
    }
  }
}
.passwordField {
  position: relative;
  width: 100%;
}
.passwordField .passwordToggle {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  cursor: pointer;
  z-index: 999;
}
.marginBottom20P{
  margin-bottom: 20px;
}
</style>
